import React from 'react';
import Alert from 'components/ui/Alert';
import { accessorialPaid } from 'helpers/accessorials';

const CarrierMismatchBanner = ({ t, accessorial, shipment }) => {
  const shipmentCarrier = shipment?.carrier?._id || shipment?.carrier;
  const carrierAssociatedWithAccessorial =
    accessorial.carrier?._id || accessorial.carrier;
  const carrierMismatch =
    accessorial.payee_type === 'carrier' &&
    shipmentCarrier !== carrierAssociatedWithAccessorial;

  const payableIsProcessed = accessorialPaid(shipment, accessorial);
  const alreadyDeclined = accessorial.carrier_status === 'declined';

  if (!carrierMismatch || payableIsProcessed || alreadyDeclined) {
    return null;
  }

  return (
    <Alert
      dataTestId="Alert-Carrier-Mismatch-Info"
      type="info"
      className="mb-4"
    >
      {t('CARRIER_MISMATCH_DECLINE_INFO', {
        defaultValue:
          'The carrier on this accessorial does not match the shipment carrier. You can still manually decline this accessorial if needed.',
      })}
    </Alert>
  );
};

export default CarrierMismatchBanner;
